// extracted by mini-css-extract-plugin
export default {"disabled":"LastBlock_disabled__a+AOu","content":"LastBlock_content__AckLm","title":"LastBlock_title__YntO9","glitch":"LastBlock_glitch__nvXBf","glitch2":"LastBlock_glitch2__dfoWh"};